<mat-form-field [appearance]="appearance">
    <mat-label>{{label}}</mat-label>
    <input type="text" matInput [formControl]="control" placeholder="{{placeholder}}" 
        [matAutocomplete]="auto" (input)="onChangeInput($event)"
    >
    <mat-autocomplete #auto="matAutocomplete" [nbSpinner]="isLoading" (optionSelected)="onOptionSelected($event)">
        <div class="autocomplete-content" infiniteScroll (scrolled)="onScroll()" 
            [infiniteScrollDistance]="infiniteScrollDistance" 
            [infiniteScrollThrottle]="infiniteScrollThrottle" [scrollWindow]="false" 
            [immediateCheck]="true" [alwaysCallback]='true'
        >
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option[displayKey]">
                {{option[displayKey]}}
            </mat-option>
            
            <div *ngIf="isLoading" class="loading-spinner-container">
                <mat-spinner [diameter]="30"></mat-spinner>
            </div>
        </div>
    </mat-autocomplete>
    <mat-error *ngIf="control.errors && (control.dirty ||control.touched)">
        {{!!errorMessage ? errorMessage : control['errorMessage']}}</mat-error>
</mat-form-field>